export default class PageState {
  //模板生成============================================================================
  self: any = null;
  title: string = "";
  theme: string = "";
  commonPub: string = localStorage.getItem('commonPub') || ""; // 公共发布标识，用于区分页面逻辑和UI
  //============================================================================
}
